import React from 'react';
import { useTranslation } from 'react-i18next';
import type { HeatBracket, Round } from '@iziping/common';
import './HeatBracketDisplay.css';
import RoundBracketDisplay from './RoundBracketDisplay';

interface HeatBracketDisplayProps {
    bracket: HeatBracket;
}

const getRoundLabel = (roundNumber: number, t: ReturnType<typeof useTranslation>['t']): string => {
    if (roundNumber === 0) return t('tournament.view.bracket.round.final');
    return t('tournament.view.bracket.round.fraction', { n: Math.pow(2, roundNumber) });
};

const HeatBracketDisplay: React.FC<HeatBracketDisplayProps> = ({ bracket }) => {
    const { t } = useTranslation();
    return (
        <div className="bracket-container">
            {bracket ? (
                <div className="bracket-wrapper">
                    <div className="bracket-headers">
                        {bracket.rounds?.map((round: Round, i) => (
                            <div key={i} className="bracket-header-cell">
                                <span className="round-label">{getRoundLabel(round.number, t)}</span>
                            </div>
                        ))}
                    </div>
                    <div className="bracket-body">
                        {bracket.rounds?.map((round: Round, index) => (
                            <RoundBracketDisplay key={index} round={round} index={index} />
                        ))}
                    </div>
                </div>
            ) : (
                <p className="bracket-empty">Sélectionner une série</p>
            )}
        </div>
    );
};

export default HeatBracketDisplay;
